import {connect} from "react-redux";
import {createHouse} from "../actions/houseActions";
import {isOnline} from "../actions/userActions";
import {loadTimezones} from "../actions/timezoneActions";
import {push} from "react-router-redux";
import {isProcessing} from "../actions/processingActions";
import {PROC_CREATE_HOUSE, PROC_TIMEZONES} from "../actions/index";
import HouseCreate from "../components/HouseCreate";
import {showSnackbar} from "../actions/snachbarActions";

const m2s = (state) => ({
	timezones: state.timezones,
	isCreating: isProcessing(state, PROC_CREATE_HOUSE),
	isFetchingTimezones: isProcessing(state, PROC_TIMEZONES)
});
const m2d = (dispatch) => {
	dispatch(isOnline(() => {
		dispatch(loadTimezones());
	}));
	return {
		onCreate: (house, onSuccess) => dispatch(createHouse(house, (result) => {
			onSuccess && onSuccess(result);
			dispatch(showSnackbar('snackbar.house.created'))
		})),
		afterCreate: (id) => dispatch(push(id ? `/houses/${id}` : '/houses')),
		onBack: () => dispatch(push('/houses'))
	};
};
export default connect(m2s, m2d)(HouseCreate);


// WEBPACK FOOTER //
// ./src/containers/HouseCreateController.js